import { ABOUT_IMAGE } from "../lib/data";

export default function About() {
    return (
        <section
            id="sobre-mi"
            data-testid="about-section"
            className="relative py-14 sm:py-20 bg-[#FAFAF8] overflow-hidden"
        >
            <span
                className="garcia-watermark absolute -left-10 top-10 text-[180px] lg:text-[260px] hidden md:block"
                aria-hidden="true"
            >
                GARCÍA
            </span>

            <div className="relative max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-20 items-center">
                <div className="reveal-photo">
                    <div className="relative aspect-[4/5] overflow-hidden">
                        <img
                            src={ABOUT_IMAGE}
                            alt="Silvia García, fotógrafa profesional de bodas en Bilbao y País Vasco"
                            className="w-full h-full object-cover"
                            data-testid="about-image"
                        />
                        <div
                            className="absolute -bottom-4 -right-4 w-24 h-24 hidden sm:block"
                            style={{ border: "1px solid #C4A882" }}
                            aria-hidden="true"
                        />
                    </div>
                </div>

                <div className="reveal reveal-delay-2">
                    <div className="flex items-center gap-4 mb-6">
                        <span className="gold-line" aria-hidden="true" />
                        <span className="text-[10px] tracking-[0.4em] uppercase text-[#6b665f]">
                            Sobre mí
                        </span>
                    </div>

                    <h2
                        data-testid="about-title"
                        className="font-display text-3xl sm:text-5xl lg:text-6xl text-[#1C1A18] leading-[1.05] font-light"
                    >
                        Soy{" "}
                        <span className="font-script text-4xl sm:text-6xl lg:text-7xl text-[#1C1A18] align-baseline">
                            Silvia
                        </span>
                        ,
                        <br />
                        fotógrafa con alma de narradora.
                    </h2>

                    <div className="mt-8 space-y-5 text-[#3b3833] font-light text-[15px] sm:text-base leading-relaxed max-w-xl border-l border-[#C4A882] pl-6">
                        <p data-testid="about-paragraph-1">
                            Creo en la fotografía honesta, en la luz natural y
                            en esos instantes que ocurren entre foto y foto.
                            Cada boda, cada cumpleaños, cada sesión es una
                            historia diferente — y mi trabajo es contarla con
                            imágenes que duren toda la vida.
                        </p>
                        <p
                            className="font-display italic text-2xl text-[#1C1A18]"
                            data-testid="about-paragraph-2"
                        >
                            No solo hago fotos. Creo recuerdos que puedes tocar.
                        </p>
                    </div>

                    <div className="mt-10 flex items-center gap-8 text-[#6b665f] text-xs tracking-[0.28em] uppercase">
                        <div>
                            <span className="block font-display text-3xl text-[#C4A882] mb-1">
                                ✦
                            </span>
                            Profesional
                        </div>
                        <div>
                            <span className="block font-display text-3xl text-[#C4A882] mb-1">
                                ∞
                            </span>
                            historias
                        </div>
                        <div>
                            <span className="block font-display text-3xl text-[#C4A882] mb-1">
                                ∞
                            </span>
                            recuerdos
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
